export default __webpack_public_path__ + "static/media/spaceman.48002bd7.png";